import { DEFAULT_LIGHTING_PANEL } from "./lib/constants";

const initialState = {
    isDirty: false,
    panel: { ...DEFAULT_LIGHTING_PANEL },
};

const reducer = (state, action) => {
    switch (action.type) {
        case "UPDATE_STATE":
            const updatedPanel = {
                ...state.panel,
                [action.key]: action.value,
            };

            return {
                ...state,
                isDirty: true,
                panel: updatedPanel,
            };
        case "SAVE_PANEL":
            return {
                ...state,
                isDirty: action.isDirty,
                panel: action.panel,
            };
        case "SET_DIRTY_FLAG":
            return {
                ...state,
                isDirty: action.isDirty,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
